export const add3DBuildingsLayer = (map) => {
  if (!map) return;

  const ensure = () => {
    try {
      if (!map.getLayer('building-hit')) {
        map.addLayer(
          {
            id: 'building-hit',
            type: 'fill',
            source: 'composite',
            'source-layer': 'building',
            filter: ['==', 'extrude', 'true'],
            paint: { 'fill-opacity': 0 },
          }
        );
      }

      if (!map.getLayer('3d-buildings')) {
        map.addLayer({
          id: '3d-buildings',
          source: 'composite',
          'source-layer': 'building',
          filter: ['==', 'extrude', 'true'],
          type: 'fill-extrusion',
          minzoom: 15,
          paint: {
            'fill-extrusion-color': '#0011a8',
            'fill-extrusion-height': [
              'interpolate', ['linear'], ['zoom'],
              15, 0, 15.05, ['get', 'height'],
            ],
            'fill-extrusion-base': [
              'interpolate', ['linear'], ['zoom'],
              15, 0, 15.05, ['get', 'min_height'],
            ],
            'fill-extrusion-opacity': 0.6,
          },
        });
      }

      const drawBase = (map.getStyle()?.layers || []).find(l => l.id?.startsWith('gl-draw-polygon'));
      if (drawBase?.id) {
        if (map.getLayer('building-hit')) map.moveLayer('building-hit', drawBase.id);
        if (map.getLayer('3d-buildings')) map.moveLayer('3d-buildings', drawBase.id);
      }
    } catch (e) {
      // e
    }
  };

  if (map.isStyleLoaded()) {
    ensure();
  } else {
    map.once('load', ensure);
  }

  const onStyle = () => ensure();
  map.off('styledata', onStyle);
  map.on('styledata', onStyle);

  if (map.getLayer('gl-draw-polygon-fill-inactive.cold')) {
    map.moveLayer('3d-buildings', 'gl-draw-polygon-fill-inactive.cold');
  }
};

export const clearLayers = (map) => {
  if (!map) return;
  if (map.getLayer("line")) map.removeLayer("line");
  if (map.getLayer("line-outline")) map.removeLayer("line-outline");
  if (map.getSource("line")) map.removeSource("line");
};

export const ensureLotPerimeterLayersOnTop = (map) => {
  if (!map) return;
  ["line", "line-outline"].forEach(id => {
    if (map.getLayer(id)) map.moveLayer(id);
  });
};
